import React, {useState} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component"
import usePort from "../hooks/usePort";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import PortStatusListDropdownComponent from "../common/port-status-list-dropdown.component";

const UpdateStatusDialog = (props) => {
    const {open, setOpen, selectedPort} = props;
    
    const {isUpdatingPortStatus, updatePortStatus} = usePort();

    const [selectedStatus, setSelectedStatus] = useState(selectedPort?.status);


    const handleStatusChange = (value) => {
        setSelectedStatus(value);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleUpdateStatus = () => {
        const parameters = {
            portUID: selectedPort?.portUid,       
            status: selectedStatus,
        }

        updatePortStatus(parameters);
    }

    const actions = [
        {
            label: "Cancel",
            onClick: (e) => setOpen(false),
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Update",
            onClick: (e) => (selectedStatus && selectedStatus !== selectedPort?.status) ? handleUpdateStatus(e) : null,
            customStyles: {
                opacity: (selectedStatus && selectedStatus !== selectedPort?.status && !isUpdatingPortStatus) ? "100%" : "55%",
                cursor: (selectedStatus && selectedStatus !== selectedPort?.status && !isUpdatingPortStatus) ? "pointer" : "not-allowed !important",
                visibility: (isUpdatingPortStatus) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isUpdatingPortStatus) ? null : handleClose}
                title="Update Status"
                subtitle={"Manage port status in real-time"}
                hasDividers={true}
                content={
                    <Box>
                        {(isUpdatingPortStatus) ? 
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating port status..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Status"}
                                    customStyles={{
                                        mb: (selectedStatus) ? 2 : 1
                                    }}
                                />

                                <PortStatusListDropdownComponent 
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    fullWidth={true}
                                    size={"medium"}
                                /> <br/>
                            </>
                        }
                    </Box>
                }
                actions={!isUpdatingPortStatus && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateStatusDialog
